import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

const defaultBoxShadow = "inset 0px -1px 0px #f0f0f0";
interface WrapperProps {
  backgroundColor?: string;
  hasBoxShadow?: boolean;
}
export const Wrapper = styled("div")(
  ({ backgroundColor = colors.gray25, hasBoxShadow = true }: WrapperProps) => ({
    height: 64,
    boxShadow: hasBoxShadow ? defaultBoxShadow : "none",
    backgroundColor,

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    padding: "0 2rem",

    "@media screen and (max-width: 435px)": {
      padding: hasBoxShadow ? "0 2rem" : "0 1rem",
    },
  })
);

const styles = makeStyles(() => ({
  operationWrapper: {
    padding: "24px 32px",
  },
  operationHeader: {
    marginBottom: 24,
  },
  operationHeaderBreadcrumb: {
    "& ol": {
      alignItems: "flex-end",
    },
  },
  operationHeaderBreadcrumbTitle: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#0055A4",
    cursor: "pointer",
  },
  operationHeaderBreadcrumbSubTitle: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#1D2939",
  },
}));

export default styles;
